module.exports = __webpack_public_path__ + "static/dog-l-gray-e1dcc54edb4d1f89ac7d5cd1a26f2408.jpg";